export enum DeviceLicenseKeyStatusEnum {
    PENDING = 'pending',
    SUCCESS = 'success',
    ERROR = 'error',
}
